import { ShoppingCartIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import RiyalSymbol from '../../../assets/svg/RiyalSymbol';
import useCart from '../../../hooks/use-cart';

interface FloatingCTAProps {
  quantity: number;
  price: number;
  productId: string;
}

export default function FloatingCTA({ quantity, price, productId }: FloatingCTAProps) {
  const { t } = useTranslation();
  const { addItemToCart } = useCart();
  const { locale } = useParams();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`
        fixed bottom-0 left-0 right-0 z-20 border-t border-gray-200 bg-white shadow-lg lg:hidden
        transition-transform duration-500 ease-in-out // 3. Add transition classes
        ${isMounted ? 'translate-y-0' : 'translate-y-full'} // 4. Conditionally apply transform
      `}
    >
      <div className='mx-auto max-w-7xl px-4 sm:px-6'>
        <div className='flex flex-col gap-3 py-3 sm:flex-row sm:items-center sm:justify-between'>
          <div className='flex items-baseline justify-between'>
            <span className='text-sm text-secondary'>{t('checkout.orderSummary.total')}</span>
            <span className='text-lg font-bold text-primary flex items-center' dir='ltr'>
              <RiyalSymbol color='currentColor' width={16} height={16} />
              <span>{price}</span>
            </span>
          </div>
          <div className='flex w-full items-center gap-3 sm:w-auto'>
            <button
              type='button'
              onClick={() => addItemToCart(productId, quantity)}
              className='flex flex-1 items-center justify-center rounded-md border border-transparent bg-primary px-2 py-3 text-base font-medium text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600'
            >
              <ShoppingCartIcon className='h-5 w-5 ltr:mr-2 rtl:ml-2' aria-hidden='true' />
              {t('cart.addToCart')}
            </button>

            <Link
              to={`/${locale}/checkout`}
              className='flex flex-1 items-center justify-center rounded-md border border-gray-300 bg-white px-2 py-3 text-base font-medium text-primary shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
            >
              {t('cart.checkout')}
              <ArrowLeftIcon className='h-5 w-5 ltr:ml-2 rtl:mr-2' aria-hidden='true' />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
